import q from '../query';
import keys from '@debbie/common/dist/cache/keys';
import * as api from '../api/creditors';
export const creditorsEntity = 'creditors';
export const creditorKey = (id) => `creditors-${id}`;
export const useCreditor = (id) => q.query(creditorKey(id), () => api.get(id), keys.read.item(creditorsEntity, id), { enabled: id != null });
export const allCreditorsKey = () => `all-creditors`;
export const useAllCreditors = (disabled) => q.query(allCreditorsKey(), () => api.getAllCreditors(), keys.read.collection(creditorsEntity), {
    enabled: !disabled,
});
export const accessCreditorsKey = () => `access-creditors`;
export const useAccessCreditors = () => q.query(accessCreditorsKey(), () => api.accessTo(), keys.read.collection(creditorsEntity));
//# sourceMappingURL=index.js.map